import '../stylesheets/application.scss';
import '../js/bootstrap';
import '../js/turbo';
import '@hotwired/turbo-rails';
import '@hotwired/hotwire-native-bridge';
import 'trix';
import '@rails/actiontext';

import { Application } from '@hotwired/stimulus';
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers';

// Set up stimulus.js https://stimulus.hotwired.dev/
const application = Application.start();
const context = require.context('../stimulus/controllers', true, /.(js|ts)$/u);

require.context('../images', true, /.(svg|png|jpg|webp)$/u);

application.load(definitionsFromContext(context));

// If you don't want to load all Stimulus controllers in this pack, you
// can either use separate folders for each set of controllers you want to
// load or you can remove the `definitionsFromContext` stuff here and
// instead import each controller explicitly e.g.
//
//   import HelloController from "../stimulus/controllers/hello_controller"
//   application.register("hello", HelloController)
//   import OtherController from "../stimulus/controllers/other_controller"
//   application.register("other", OtherController)

// Configure stimulus development experience
application.debug = false;
// window.Stimulus = application;
